import {useState} from "react";
import * as Yup from "yup";

import {FormikForm} from "@pg-mono/formik-utils";

import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {validationMessages} from "../../../form/utils/validation_messages";
import {useAppSelector} from "../../../store/hooks";
import {HomeMatchBasicPreferencesFlow} from "../../../user/components/home_match_basic_preferences_flow/HomeMatchBasicPreferencesFlow";
import {ViewType} from "../../../view_type/ViewType";
import {FavouritesApplicationFormHandler, IFavouritesApplicationFormHandlerProps} from "./FavouritesApplicationFormHandler";
import {FavouritesApplicationForm} from "./FavourtiesApplicationForm";
import {getInitialFavouritesListApplicationFormValues} from "./utils";

type IProps = IFavouritesApplicationFormHandlerProps;
type FavouritesApplicationSuccessArgs = Parameters<NonNullable<IFavouritesApplicationFormHandlerProps["onSubmitSuccess"]>>;

export const FavouritesApplication = (props: IProps) => {
    const [pendingSuccessArgs, setPendingSuccessArgs] = useState<FavouritesApplicationSuccessArgs | null>(null);
    const viewType = useAppSelector((state) => state.viewType.current);
    const homeMatchBasicEventCategory =
        viewType === ViewType.COMPARISON_TOOL ? GTMEventApplicationSourceSection.COMPARISON_TOOL : GTMEventApplicationSourceSection.SIDEBAR_MY_LIST;

    const validationSchema = Yup.object({
        email: Yup.string().required(validationMessages.required).email(validationMessages.email),
        name: Yup.string().required(validationMessages.required),
        phone: Yup.object({
            code: Yup.number().required(),
            number: Yup.string().required(validationMessages.required).min(1, validationMessages.required)
        }),
        marketing_email: Yup.boolean().required().oneOf([true], validationMessages.required)
    });

    const handleHomeMatchBasicComplete = () => {
        if (pendingSuccessArgs) {
            props.onSubmitSuccess?.(...pendingSuccessArgs);
        }

        setPendingSuccessArgs(null);
    };

    return (
        <div>
            <FormikForm
                initialValues={getInitialFavouritesListApplicationFormValues()}
                onSubmit={(_, {setSubmitting}) => {
                    setSubmitting(true);
                }}
                validationSchema={validationSchema}
                validateOnMount
            >
                <FavouritesApplicationForm />
                <FavouritesApplicationFormHandler
                    {...props}
                    onSubmitSuccess={(...args) => {
                        setPendingSuccessArgs(args);
                    }}
                />
            </FormikForm>
            {pendingSuccessArgs && (
                <HomeMatchBasicPreferencesFlow
                    isOpen
                    source="afterLead"
                    initialStep="auto"
                    defaultHomeMatchBasicConsent={false}
                    trackingContext={{
                        eventName: "modal_post_lead",
                        eventCategory: homeMatchBasicEventCategory,
                        sourceModal: "modal_post_lead"
                    }}
                    onComplete={handleHomeMatchBasicComplete}
                />
            )}
        </div>
    );
};
import {useState} from "react";
import * as Yup from "yup";

import {FormikForm} from "@pg-mono/formik-utils";

import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {validationMessages} from "../../../form/utils/validation_messages";
import {useAppSelector} from "../../../store/hooks";
import {HomeMatchBasicPreferencesFlow} from "../../../user/components/home_match_basic_preferences_flow/HomeMatchBasicPreferencesFlow";
import {ViewType} from "../../../view_type/ViewType";
import {FavouritesApplicationFormHandler, IFavouritesApplicationFormHandlerProps} from "./FavouritesApplicationFormHandler";
import {FavouritesApplicationForm} from "./FavourtiesApplicationForm";
import {getInitialFavouritesListApplicationFormValues} from "./utils";

type IProps = IFavouritesApplicationFormHandlerProps;
type FavouritesApplicationSuccessArgs = Parameters<NonNullable<IFavouritesApplicationFormHandlerProps["onSubmitSuccess"]>>;

export const FavouritesApplication = (props: IProps) => {
    const [pendingSuccessArgs, setPendingSuccessArgs] = useState<FavouritesApplicationSuccessArgs | null>(null);
    const viewType = useAppSelector((state) => state.viewType.current);
    const homeMatchBasicEventCategory =
        viewType === ViewType.COMPARISON_TOOL ? GTMEventApplicationSourceSection.COMPARISON_TOOL : GTMEventApplicationSourceSection.SIDEBAR_MY_LIST;

    const validationSchema = Yup.object({
        email: Yup.string().required(validationMessages.required).email(validationMessages.email),
        name: Yup.string().required(validationMessages.required),
        phone: Yup.object({
            code: Yup.number().required(),
            number: Yup.string().required(validationMessages.required).min(1, validationMessages.required)
        }),
        marketing_email: Yup.boolean().required().oneOf([true], validationMessages.required)
    });

    const handleHomeMatchBasicComplete = () => {
        if (pendingSuccessArgs) {
            props.onSubmitSuccess?.(...pendingSuccessArgs);
        }

        setPendingSuccessArgs(null);
    };

    return (
        <div>
            <FormikForm
                initialValues={getInitialFavouritesListApplicationFormValues()}
                onSubmit={(_, {setSubmitting}) => {
                    setSubmitting(true);
                }}
                validationSchema={validationSchema}
                validateOnMount
            >
                <FavouritesApplicationForm />
                <FavouritesApplicationFormHandler
                    {...props}
                    onSubmitSuccess={(...args) => {
                        setPendingSuccessArgs(args);
                    }}
                />
            </FormikForm>
            {pendingSuccessArgs && (
                <HomeMatchBasicPreferencesFlow
                    isOpen
                    source="afterLead"
                    initialStep="auto"
                    defaultHomeMatchBasicConsent={false}
                    trackingContext={{
                        eventName: "modal_post_lead",
                        eventCategory: homeMatchBasicEventCategory,
                        sourceModal: "modal_post_lead"
                    }}
                    onComplete={handleHomeMatchBasicComplete}
                />
            )}
        </div>
    );
};
